module.exports = __webpack_public_path__ + "static/media/021-summer.72ec5113.svg";